import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-open-bankid-button',
  templateUrl: './open-bankid-button.component.html',
  styleUrls: ['./open-bankid-button.component.scss'],
})
export class OpenBankidButtonComponent implements OnInit {

  constructor(public platform: Platform) { }

  get isMobile() {
    return this.platform.is('mobile');
  }

  ngOnInit() {}

}
